import React from "react";
import {
	Container,
	Box,
	Typography,
	Button,
	Paper,
} from "@mui/material";
import { TextFieldControl } from "@haohan/form-ui"
import { useForm } from "react-hook-form";
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';

import { SiteAuthHeader } from "../../components/AuthHeader";
import { SiteRouterLink } from "../../../components/RouterLink";
import { AuthPaper } from "../../components/AuthPaper";
import { useI18n } from "./locales";
import { AuthSetupPasswordForm } from "./Form";
import { papi } from "@haohan-frontend/papi";
import { Helmet } from "react-helmet-async";
import { AuthSetupPasswordFormSuccess } from "./Success";

export function AuthSetupPassword() {
	const { t } = useI18n();
	const [ success, setSuccess ] = React.useState(false);
	return (
		<>
			<Helmet>
				<title>{t('Password reset')} — Haohan</title>
			</Helmet>
			<SiteAuthHeader/>
			<main>
				<Container maxWidth="xs" sx={{pb: 8, pt: 14}}>
					<AuthPaper
						rightColumn={(
							<>
								<Typography
									display='block'
									fontWeight='bold'
									mb={.5}
									textAlign='center'
									variant='h6'
								>
									{t('Password reset')}
								</Typography>
								<Box position='relative'>
									{success && (
										<Box mt={2}>
											<AuthSetupPasswordFormSuccess />
										</Box>
									)}
									<Box visibility={success ? 'hidden' : 'visible'}>
										<AuthSetupPasswordForm
											onSuccess={() => setSuccess(true)}
										/>

									</Box>
								</Box>
							</>
						)}
					/>
				</Container>
			</main>
		</>
	);
}
